var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canSee)?_c(_vm.domNode,{tag:"component",class:['sidebar-item', {
    'sidebar-item_active': _vm.activeLink,
    'sidebar-item_disabled': _vm.isDisabled,
    'sidebar-item_ellipsis': _vm.textEllipsis,
    'sidebar-item_lv-1': _vm.icon
  }],attrs:{"to":_vm.to,"href":_vm.href || undefined,"target":_vm.target,"exact":_vm.to ? true : false},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"sidebar-item__icon"},[(_vm.icon)?_c('KonturIcon',{attrs:{"size":"24","name":_vm.icon}}):_vm._e()],1),_c('span',{class:['sidebar-item__title', {'sidebar-item__title_ellipsis': _vm.textEllipsis}]},[_vm._t("default")],2),(_vm.tag)?_c('vs-chip',{staticClass:"sidebar-item__tag"},[_vm._v(_vm._s(_vm.tag))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }